
export const patterns = {
  1: [1,2,3,4,5,6,7],
  2: [7,6,5,4,3,2,1],
  3: [1,2,3,4,5,6,7,6,5,4,3,2],
  4: [1,7,2,6,3,5,4,6]
}

export const moods = {
  1: ["G3", "A3", "B3", "D4", "A4", "D5","E5"],
  2: ["D3", "E3", "F#3", "A3", "E4", "A4","B4"],
  3: ["C3", "D3", "E3", "G3", "D4", "G4","A4"],
  4: ["E3", "F#3", "G3", "A3", "B3", "C#4", "D4"],
  5: ["A3", "B3", "C4", "D4", "E4", "F4", "G4"],
  6: ["F3", "G3", "G#3", "A#3", "C4", "D4", "D#4"],
  7: ["B2", "C#3", "E3", "F#3", "G#4", "B4", "C#4"]
}

export const delayTimeDiv = {  
    1: 15000,
    2: 30000,
    3: 45000,
    4: 60000  
}